selectHeadGuardian();

function selectHeadGuardian(){
    var AjaxController = require('./services/AjaxController');

    $('.js-select-main-contact').on('click', function () {

        var $this = $(this),
            contactId = $this.data('contact'),
            url = '/api/clients/main-contact';

        var data = {
            contactId: contactId,
            value: ($this.prop('checked')) ? 1 : 0
        };
        var success = function () {
            if(data.value === 1) {
                $("tr[data-contact-header='" + data.contactId +"']").children('td:first').html('<span class="main_contact">Main Contact</span>');
            } else {
                $("tr[data-contact-header='" + data.contactId +"']").children('td:first').html('<span class="main_contact"></span>');
            }
        }
        var error = function () {
            //console.log('Error');
        }

        AjaxController.prototype.send(url, data, success, error);
    });
}
